import React, { useState, useEffect } from "react";
import { Music, Heart, Users } from "lucide-react";

const culturalStories = {
  "Hip Hop": {
    title: "L'Esprit du Hip Hop",
    content: "Le Hip Hop est bien plus qu'un style musical, c'est un mouvement culturel né dans les quartiers du Bronx dans les années 70. Il représente l'expression artistique, la résistance et la créativité face à l'adversité. De Grandmaster Flash à Kendrick Lamar, le Hip Hop continue d'évoluer tout en restant fidèle à ses racines de contestation sociale et d'authenticité.",
    icon: Music,
  },
  "Hip-Hop/RNB": {
    title: "Hip-Hop & RNB : Une Alliance Puissante",
    content: "Le Hip-Hop et le RNB partagent des racines communes dans la culture afro-américaine. Ensemble, ils créent un son unique qui mélange les beats percutants du rap avec les mélodies soul du RNB. Des collaborations légendaires ont marqué l'histoire de la musique urbaine, créant des hymnes qui traversent les générations.",
    icon: Music,
  },
  "Afrobeat": {
    title: "Les Rythmes de l'Afrobeat",
    content: "L'Afrobeat est né de la fusion du jazz, du funk et des rythmes traditionnels africains, popularisé par le légendaire Fela Kuti dans les années 70. Ce genre musical incarne la fierté africaine et la lutte pour la justice sociale. Aujourd'hui, des artistes comme Burna Boy et Wizkid portent l'héritage de l'Afrobeat à l'échelle mondiale, mêlant tradition et modernité.",
    icon: Heart,
  },
  "Dancehall/Caraïbes": {
    title: "L'Énergie du Dancehall",
    content: "Le Dancehall jamaïcain est une explosion d'énergie et de créativité qui a conquis le monde. Né dans les années 70-80, ce genre mélange reggae, influences caribéennes et beats électroniques. Avec ses riddims contagieux et son flow unique, le Dancehall est devenu un pilier de la musique urbaine mondiale.",
    icon: Users,
  },
  "RNB": {
    title: "L'Âme du RNB",
    content: "Le Rhythm and Blues (RNB) trouve ses racines dans la soul, le gospel et le blues afro-américain des années 40. Genre musical intime et émotionnel, le RNB explore l'amour, les relations et les expériences personnelles avec une sensibilité unique. Des pionniers comme Aretha Franklin aux artistes contemporains comme The Weeknd, le RNB continue de toucher les cœurs.",
    icon: Users,
  },
};

export const CulturalStory = ({ selectedCategory }) => {
  const [currentFact, setCurrentFact] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Don't show story for "all" category
    if (selectedCategory === "all") {
      setCurrentFact(null);
      setIsVisible(false);
      return;
    }

    const story = culturalStories[selectedCategory];
    
    if (story) {
      setCurrentFact(story);
      setTimeout(() => {
        setIsVisible(true);
      }, 100);
    } else {
      setCurrentFact(null);
      setIsVisible(false);
    }
  }, [selectedCategory]);

  if (!currentFact) return null;

  const Icon = currentFact.icon;

  return (
    <div 
      className={`glass-card rounded-lg p-6 border-l-4 border-primary transition-all duration-700 transform ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
      data-testid="cultural-story-card"
    >
      <div className="flex items-start gap-4">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="relative">
            <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center">
              <Icon className="w-6 h-6 text-primary" />
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1">
          <h3 className="text-lg font-bold mb-2">{currentFact.title}</h3>
          
          <p className="text-muted-foreground text-sm leading-relaxed">
            {currentFact.content}
          </p>
        </div>
      </div>
    </div>
  );
};
